module.exports = __webpack_public_path__ + "static/media/1.58797534.jpg";